<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img src="favicon.ico" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/">
            <el-dropdown-item>主页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="changePassWord">
            <span style="display:block;">修改密码</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog :title="'修改密码'" :visible.sync="dialogVisible" append-to-body width="600px" center>
      <el-form ref="form" :model="singleArr" :rules="formRules" label-width="auto">
        <el-form-item label="旧密码" prop="oldpsw">
          <el-input type="password" v-model="singleArr.oldpsw" />
        </el-form-item>
        <el-form-item label="新密码" prop="newpsw">
          <el-input type="password" v-model="singleArr.newpsw" />
        </el-form-item>
        <el-form-item label="再次输入" prop="secpsw">
          <el-input type="password" v-model="singleArr.secpsw" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleChange">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import api from "@/api";
import Hamburger from "@/components/Hamburger";

export default {
  data() {
    return {
      dialogVisible: false,
      singleArr: {},
      formRules: {
        oldpsw: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newpsw: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        secpsw: [
          { required: true, message: "请再次输入新密码", trigger: "blur" }
        ]
      }
    };
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    changePassWord() {
      this.dialogVisible = true;
    },
    handleChange() {
      if (this.singleArr.newpsw !== this.singleArr.secpsw) {
        this.$message({
          type: "error",
          message: "两次新密码不一致"
        });
        return;
      }
      if (this.singleArr.newpsw.length < 6) {
        this.$message({
          type: "error",
          message: "密码长度不能低于6位"
        });
        return;
      } else {
        const query = {
          oldPassword: this.singleArr.oldpsw,
          newPassword: this.singleArr.newpsw
        };
        api.user.updatePassword(query).then(response => {
          if (response.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功"
            });
          }
          this.dialogVisible = false;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
